var _$Cancel_4 = {};
"use strict";

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function () {
  return "Cancel" + (this.message ? ": " + this.message : "");
}, Cancel.prototype.__CANCEL__ = !0, _$Cancel_4 = Cancel;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhbmNlbC5qcyJdLCJuYW1lcyI6WyJDYW5jZWwiLCJtZXNzYWdlIiwidGhpcyIsInByb3RvdHlwZSIsInRvU3RyaW5nIiwiX19DQU5DRUxfXyIsIm1vZHVsZSJdLCJtYXBwaW5ncyI6IjtBQUFBLFlBQUEsQ0FBQTs7QUFRQSxTQUFTQSxNQUFULENBQWdCQyxPQUFoQixFQUFnQkE7RUFDZEMsSUFBQUEsQ0FBS0QsT0FBTEMsR0FBZUQsT0FBZkMsQ0FBQUE7Q0FHRkY7O0FBQUFBLE1BQUFBLENBQU9HLFNBQVBILENBQWlCSSxRQUFqQkosR0FBNEIsWUFBQTtFQUMxQixPQUFPLFFBQUEsSUFBWUUsSUFBQUEsQ0FBS0QsT0FBTEMsR0FBZSxJQUFBLEdBQU9BLElBQUFBLENBQUtELE9BQTNCQyxHQUFxQyxFQUFqRCxDQUFQLENBQUE7Q0FERkYsRUFJQUEsTUFBQUEsQ0FBT0csU0FBUEgsQ0FBaUJLLFVBQWpCTCxHQUFpQkssQ0FBYSxDQUo5QkwsRUFNQU0sVUFBQUEsR0FBaUJOLE1BTmpCQSxDQUFBQSIsInNvdXJjZXNDb250ZW50IjpbbnVsbF19